import * as voucherApplications from '../api/voucher-applications';
import { fetchLoadable } from '../fetchLoadable';
import * as actionTypes from './actionTypes';
export const getVoucherApplications = (tenantId) => fetchLoadable(actionTypes.FETCH_VOUCHER_APPLICATIONS, voucherApplications.getAll, { tenantId });
//# sourceMappingURL=actions.js.map